<template>
  <v-row>
    <v-col cols="12" v-if="user && user.onboarding && stepper == 1">
      <v-dialog v-model="dialog" persistent fullscreen>
        <v-card :loading="loading">
          <v-card-title :class="`${arabic?'arFont':'enFont'}`"  style="font-size:20px">
            <v-row class="align-center fill-height">
              <v-col cols="12" md="11" :class="`${arabic?'arFont':'enFont'} fill-height`">
                {{  i18n['welcome_to_ninja_sellers'] }}
                
              </v-col>
              <v-col cols="12" md="1" :class="`${arabic?'arFont':'enFont'} fill-height`">
                <v-btn text @click="signOut()" :class="`${arabic?'arFont':'enFont'}`">
                  <span class="primary--text">{{i18n.logout}}</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
          <v-card-text>
            <v-row class="align-center fill-height">
              <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} fill-height`" v-if="loading">
                <v-progress-circular indeterminate color="primary"></v-progress-circular>
              </v-col>
              <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} fill-height`">
                <v-stepper v-model="stepper" class="elevation-0">
                  <v-stepper-header class="elevation-0">
                    <v-stepper-step
                      :complete="stepper > 1"
                      step="1"
                    >
                      <span :class="`${arabic?'arFont':'enFont'} mx-1`">{{ i18n['confirm_your_email'] }}</span>
                    </v-stepper-step>

                    <v-divider></v-divider>

                    <!-- <v-stepper-step
                      :complete="stepper > 2"
                      step="2"
                    >
                      <span :class="`${arabic?'arFont':'enFont'} mx-1`">تأكيد رقم الهاتف</span>
                    </v-stepper-step>

                    <v-divider></v-divider>

                    <v-stepper-step step="3">
                      <span :class="`${arabic?'arFont':'enFont'} mx-1`">استخدام المنصة</span>
                    </v-stepper-step> -->
                  </v-stepper-header>

                  <v-stepper-items>
                    <v-stepper-content v-if="stepper == 1" step="1">
                      <v-card v-if="user && user.verified_email">
                        <v-card-text :class="`${arabic?'arFont':'enFont'}`">
                          <h2 :class="`${arabic?'arFont':'enFont'}`">{{ i18n["email_confirmed_successfully"] }}</h2>
                        </v-card-text>
                        <v-card-actions>
                          <v-btn color="primary" :class="`${arabic?'arFont':'enFont'}`" @click="()=>{stepper = 2; loadUserAgain()}">
                            {{ i18n["next"] }}
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                      <v-card v-if="!user || !user.verified_email">
                        <v-card-text :class="`${arabic?'arFont':'enFont'}`">
                          
                          <h2 :class="`${arabic?'arFont':'enFont'}`">{{ i18n['please_confirm_your_email_by_clicking_link_sent_to_your_email'] }}</h2>
                        </v-card-text>
                        <v-card-actions>
                          <v-btn color="primary" :class="`${arabic?'arFont':'enFont'}`" @click="sendEmail()">
                            {{ i18n["send_confirmation_email"] }}
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-stepper-content>
                    <!-- <v-stepper-content v-if="stepper == 2" step="2">
                      <v-card v-if="!user.verified_phone">
                        <v-card-text :class="`${arabic?'arFont':'enFont'}`">
                          <v-row class="align-center">
                            <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'}`" v-if="false">
                              <h4 :class="`${arabic?'arFont':'enFont'}`">يرجى ادخال رقم هاتفك الفعال على واتساب و سيصلك على واتساب <img height="20px" src="/images/WhatsApp.png"> رسالة نصية تحتوي على رمز لتأكيد رقم هاتفك</h4>
                            </v-col>
                            <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'}`" v-if="false">
                              <v-autocomplete
                                :items="countries"
                                v-model="country_code"
                                label="مفتاح الدولة"
                                autocomplete="disabled"
                                outlined
                                :filter="filterObject"
                                hide-details
                                clearable
                                dense
                                :loading="loading"
                                item-value="callingCodes"
                                :class="`${arabic?'arFont':'enFont'}`"
                              >
                                <template v-slot:selection="{ attr, on, item, selected }">
                                  <span
                                    v-bind="attr"
                                    :input-value="selected"
                                    v-on="on"
                                    :class="`${arabic?'arFont':'enFont'}`"
                                  >
                                    <v-chip x-small>{{item.callingCodes}}</v-chip>
                                  </span>
                                </template>
                                <template v-slot:item="{ item }">
                                  <span
                                    :class="`${arabic?'arFont':'enFont'}`"
                                  >
                                    {{item.name}} | {{item.callingCodes}}
                                  </span>
                                </template>
                              </v-autocomplete>
                            </v-col>
                            <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'}`" v-if="false">
                              <v-text-field
                                label="رقم الهاتف"
                                :class="`${arabic?'arFont':'enFont'}`"
                                outlined
                                dense
                                :disabled="submit"
                                :loading="loading"
                                @keypress="isNumber($event)"
                                hide-details
                                v-model="phone_number"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="4" :class="`${arabic?'arFont':'enFont'}`" v-if="false">
                              <v-btn color="primary" @click.native="sendSMS()" :loading="loading" :disabled="submit" :class="`${arabic?'arFont':'enFont'}`">ارسال الرقم السري</v-btn>
                            </v-col>
                            <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'}`">
                              <h4 :class="`${arabic?'arFont':'enFont'} mt-6`">لتفعيل الحساب يرجى التواصل عبر الوتس اب: <a href="https://api.whatsapp.com/send?phone=447883307413">
                                447883307413
                                <img height="30px" src="/images/WhatsApp.png">
                              </a></h4>
                            </v-col>
                            <v-col cols="12" md="6" :class="`${arabic?'arFont':'enFont'} text-center`" v-if="true || submit">
                              <v-text-field
                                label="كود التفعيل"
                                :class="`${arabic?'arFont':'enFont'}`"
                                outlined
                                dense
                                :loading="loading"
                                @keypress="isNumber($event)"
                                hide-details
                                v-model="secret"
                              ></v-text-field>
                            </v-col>
                            <v-col cols="12" md="6" :class="`${arabic?'arFont':'enFont'}`"  v-if="true || submit">
                              <v-btn color="primary" @click.native="sendSecret()" :loading="loading" :class="`${arabic?'arFont':'enFont'}`">تأكيد الرقم</v-btn>
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                      <v-card v-if="user.verified_phone">
                        <v-card-text :class="`${arabic?'arFont':'enFont'}`">
                          <h2 :class="`${arabic?'arFont':'enFont'}`">تم تأكيد رقم الهاتف بنجاح</h2>
                        </v-card-text>
                        <v-card-actions>
                          <v-btn color="primary" :class="`${arabic?'arFont':'enFont'}`" @click="()=>{stepper = 3; loadUserAgain()}">
                            التالي
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-stepper-content>
                    
                    <v-stepper-content v-if="stepper == 3" step="3">
                      <v-card>
                        <iframe width="100%" height="500" src="https://www.youtube.com/embed/G85hheAY78Y" title="YouTube video player"
                          frameborder="0"
                          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                          allowfullscreen></iframe>
                          <v-card-actions>
                            <v-btn color="primary" :class="`${arabic?'arFont':'enFont'}`" @click="finsihOnBoarding()">
                              الدخول للمنصة
                            </v-btn>
                          </v-card-actions>
                      </v-card>
                      <v-card v-if="false">
                        <v-card-text :class="`${arabic?'arFont':'enFont'}`">
                          <h2 :class="`${arabic?'arFont':'enFont'} mb-6`">يجب عليك حضور احد ورشات التدريب الخاصة باستخدام المنصة قبل تفعيل حسابك</h2>
                          <h4 :class="`${arabic?'arFont':'enFont'} my-2 error--text`">يرجى العلم أنه في حال عدم حضورك لورشة التدريب على المنصة يؤسفنا ابلاغك انه لن يتم تفعيل حسابك</h4>
                          <h4 :class="`${arabic?'arFont':'enFont'}`">الورشة دائما مجانية وعبر البث المباشر</h4>
                          <h4 :class="`${arabic?'arFont':'enFont'}`">هنالك ورشة جديدة كل يوم عدا يوم الجمعة</h4>
                          <h4 :class="`${arabic?'arFont':'enFont'}`">تبدأ الورشة الاولى الساعة 14:00 بتوقيت مكة المكرمة</h4>
                          <h4 :class="`${arabic?'arFont':'enFont'}`">تبدأ الورشة الثانية الساعة 17:00 بتوقيت مكة المكرمة</h4>
                          <h4 :class="`${arabic?'arFont':'enFont'}`">سيكون رابط الورشة متاح قبل بدأها ب 10 دقائق من الوقت المحدد</h4>
                          <h4 :class="`${arabic?'arFont':'enFont'} mt-6`" v-if="seminar">{{seminar.note}}</h4>
                          <h4 :class="`${arabic?'arFont':'enFont'} mt-6`">الوقت في مكة الان: <span style="direction:ltr !important" v-if="live_check">{{live_check.mekka_time}}</span></h4>
                          <h4 :class="`${arabic?'arFont':'enFont'} mt-6`">للأستفسار عبر واتساب: <a href="https://api.whatsapp.com/send?phone=447883307413">
                            447883307413
                            <img height="30px" src="/images/WhatsApp.png">
                          </a></h4>
                        </v-card-text>
                        <v-card-actions>
                          <v-btn color="primary" :class="`${arabic?'arFont':'enFont'}`" @click="refresh()">
                            refresh
                          </v-btn>
                          <v-btn color="primary" v-if="live" :class="`${arabic?'arFont':'enFont'}`" @click="startSeminar()">
                            الدخول للورشة
                          </v-btn>
                        </v-card-actions>
                      </v-card>
                    </v-stepper-content> -->
                  </v-stepper-items>
                </v-stepper>
              </v-col>
              <v-col cols="12" md="12" :class="`${arabic?'arFont':'enFont'} fill-height`">
                {{ i18n['you_can_reach_support_on_whatsapp'] }}:  <a href="https://api.whatsapp.com/send?phone=447883307413">
                  447883307413
                  <img height="30px" src="/images/WhatsApp.png">
                </a>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-col>
    <v-col cols="12" v-if="user && user.onboarding && user.role !=='business' && stepper == 2">
      <v-dialog
          transition="dialog-top-transition"
          max-width="600"
          persistent
          v-model="dialog"
          :overlay-opacity="0.7"
        >
        <v-btn color="error" text :loading="loading" :class="`${arabic ? 'arFont' : 'enFont'}`"
                @click="closeDialogAcdmia">
                {{ i18n["close"] }}
          </v-btn>
        <v-card class="text-center">
          <v-card-text class="text-center mx-auto pt-4">
            <v-icon size="50" color="primary">
              subscriptions
            </v-icon>
          </v-card-text>
          <v-card-text>
            <div :class="`${arabic ? 'arFont' : 'enFont'} pa-5 pb-2`" style="font-size:22px;font-weight:bold;">
              {{ i18n['ready_to_learn_ecom'] }}
            </div>
            <div :class="`${arabic ? 'arFont' : 'enFont'} pa-5 pt-2`" style="font-size:18px;">
              <span class="primary--text" style="font-weight:bold;">{{ i18n['ninja_sellers_camp_description_chance'] }}</span>
              {{ i18n["ninja_sellers_camp_description"] }} 
              <span class="primary--text" style="font-weight:bold;">{{ i18n['ninja_sellers_camp_tail'] }}</span>
              <!-- {{ i18n['we_provide_it_in_one_place'] }} 
              <span class="primary--text" style="font-weight:bold;">{{i18n['free']}}</span> -->
            </div>
          </v-card-text>
          <v-card-actions class="justify-center px-8">
            
            <v-btn
              color="primary"
              large block :loading="loading"
              :class="`${arabic ? 'arFont' : 'enFont'}`"
              @click="goToLink()"
            >{{ i18n['book_a_place_now'] }}
            </v-btn>

          </v-card-actions>
        </v-card>

      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import axios from 'axios'
import countries from '../countries-ash.json'
export default {
  data() {
      return {
        dialog:true,
        phone_number:null,
        country_code:null,
        submit:null,
        loading:null,
        secret:null,
        stepper:1,
        countries:countries.map(x=>{return{...x, callingCodes:x.callingCodes[0]}}),
        session_token:null,
        live:null,
        live_check:null,
        seminar:null,
      }
  },
  methods:{
    async goToLink() {
      this.loading = true
      let r2 = await this.$store.dispatch('getResource', { resource: '/user/stepthree' });
      window.location.href = 'https://camp.ninjasellers.com/';
      this.loading = false
    },
    async finsihOnBoarding() {
      let r2 = await this.$store.dispatch('getResource', { resource: '/user/endboarding' });
      this.$store.state.user = await this.$store.dispatch('getUser')
      this.dialog = false
    },
    async loadUserAgain() {
      this.loading = true
      this.$store.state.user = await this.$store.dispatch('getUser')
      this.loading = false
    },
    clearStore(){
      this.$store.state.access_token = null
      this.$store.state.user = null
      this.$store.state.uid = null
      this.$store.state.centralLogin = false
      this.$store.state.menu = []
      this.$store.state.globalLoading = false
      this.$store.state.users = []
      this.$store.state.goals = []
      this.$store.state.keyResults = []
      this.$store.state.initiatives = []
      this.$store.state.documents = []
      this.$store.state.notifications = []
      this.$store.state.approvals = []
      this.$store.state.usersLevels = []
      this.$store.state.reports = []
      this.$store.state.othersGoals = []
      localStorage.country = null
      localStorage.cart = JSON.stringify([])
      localStorage.manual_country = false
    },
    async signOut() {
      try {
        await this.$store.dispatch('logout')
      } catch (error) {
        // console.log(error)
      }
      this.clearStore()
    },
    filterObject(item, queryText, itemText) {
      let v = Object.values(item).filter(x=>typeof x == 'string')
      let a = false
      v.forEach(x=>{
        if(x.toLowerCase().includes(queryText.toLowerCase())) a = true
      })
      if(itemText && typeof itemText == 'string' && itemText.toLowerCase().includes(queryText.toLowerCase())) a = true
      return a
    },
    async sendSMS() {
      return new Promise(async(res, rej)=>{
        this.loading = true
        if(!this.phone_number) {
          this.$emit('snackbarNotification', this.i18n["phone_required"], 'error')
          this.loading = false
        }
        this.submit = true
        let r = await this.$store.dispatch('postResource', {resource:'/phone-verification', value:{phone_number:`${this.country_code}${this.phone_number}`}})
        this.session_token = r.session_token
        // console.log(r)
        this.loading = false
      })
    },
    async sendSecret() {
      return new Promise(async(res, rej)=>{
        this.loading = true
        if(!this.secret) {
          this.$emit('snackbarNotification', this.i18n['secret_required'], 'error')
          this.loading = false
        }
        let s_o = { secret:this.secret, session_token:this.session_token, phone_number:`${this.country_code}${this.phone_number}` }
        let r = await this.$store.dispatch('postResource', {resource:'/phone-verification-check', value:s_o})
        if(r.error) {
          this.$emit('snackbarNotification', this.i18n["wrong_secret_try_again"], 'error')
          this.submit = false
          this.secret = null
        } else {
          this.secret = null
          this.stepper++
          this.$emit('snackbarNotification', this.i18n['phone_confirmed'], 'success')
          this.$store.state.user = await this.$store.dispatch('getUser')
          location.reload();
        }
        // console.log(r)
        this.loading = false
      })
    },
    async sendEmail() {
      return new Promise(async(res, rej)=>{
        this.loading = true
        let r = await this.$store.dispatch('getResource', {resource:'/email-verification/' + this.user.id})
        this.$emit('snackbarNotification', this.i18n['link_sent_to_your_email'], 'success')
        // console.log(r)
        this.loading = false
      })
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode != 45 && charCode != 46 &&
      !(charCode >= 48 && charCode <= 57)) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    async getSeminar(){
      return new Promise(async(res, rej) => {
        let r = await this.$store.dispatch('getResource', {resource:'/get-cache/seminarlink'});
        // console.log(r)
        this.seminar = r.data
        res()
      })
    },
    async startSeminar(){
      return new Promise(async(res, rej) => {
        let r = await this.$store.dispatch('getResource', {resource:'/get-cache/seminarlink'});
        window.open(r.data.seminar_url, '_blank');
        let r2 = await this.$store.dispatch('getResource', {resource:'/user/endboarding'});
      })
    },
    async refresh(){
      return new Promise(async (res, rej)=>{
        await this.$store.dispatch('getUser')
        let r = await this.$store.dispatch('getResource', {resource:'/check-seminar-time'})
        this.live_check = r
        this.live = r.live
        res()
      })
    },
    async loop() {
      return new Promise(async (res, rej)=>{
        setInterval(this.refresh, 1000)
        res()
      })
    },
    async init(){
      return new Promise(async (res, rej)=>{
        // await this.loop()
        this.$store.state.user = await this.$store.dispatch('getUser')
        this.stepper = this.$store.state.user ? this.$store.state.user.onboarding_step : 1
        // await this.getSeminar()
        // await this.refresh()
        res()
      })
    },
    closeDialog() {
      this.$emit('closeDialog');
    },
    closeDialogAcdmia() {
      this.dialog = false;
    },
  },
  computed:{
    api(){
      return this.$store.state.settings.apiBase
    },
    
    // users(){
    //   let sa = this.$store.state.user && this.$store.state.user.role == 'superadmin'
    //   // console.log(sa)
    //   return this.$store.state.users.filter(x=>{
    //     if(!sa) {
    //       return x.superior == this.$store.state.user.level
    //     } else return x
    //   })
    // },
    // site(){
    //   return this.$store.state.site
    // },
    // items() {
    //   return this.$store.state.menu
    // },
    // superAdmin(){
    //   return this.$store.state.superAdmin
    // },
    // isLogin() {
    //   return this.$store.state.centralLogin
    // },
    language(){
      return this.$store.state.language
    },
    // globalLoading(){
    //   return this.$store.state.globalLoading
    // },
    user(){
      return this.$store.state.user
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
    // routeTitle(){
    //   let main = this.$store.state.menu.filter(x=>x.path == this.$route.path)
    //   let sub = [].concat(...this.$store.state.menu.map(x=>x.subs)).filter(x=>x).filter(x=>x.path == this.$route.path)
    //   if(main.length) {
    //     return this.$store.state.i18n[this.$store.state.language][main[0].text]
    //   } else if(sub.length) {
    //     return this.$store.state.i18n[this.$store.state.language][sub[0].text]
    //   } else {
    //     return ''
    //   }
    // },
    // roles(){
    //   return this.$store.state.userRoles
    // },
    // notifications(){
    //   return this.$store.state.notifications.sort((a, b)=> b.timestamp - a.timestamp)
    // },
    // paymentMethods(){
    //   return this.$store.state.paymentMethods
    // },
  },
  async created(){
    await this.init()
  }
}
</script>

<style>

</style>